import ProductDetailsIcon, { ProductDetailsIconProps, PRODUCT_DETAILS_ICONS } from './ProductDetailsIcon'

export default ProductDetailsIcon

export { PRODUCT_DETAILS_ICONS }
export type { ProductDetailsIconProps }
